// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__5HEXV","section-1":"styles_section-1__R7+kv","content":"styles_content__cc6Zp","section-2":"styles_section-2__fCmiy"};